import { Box, Text } from '@medly-components/core';
import styled from 'styled-components';
import { ReactComponent as BottomRightYellowVector } from '../../../assets/svg/bottom_right_yellow_vector.svg';
import { ReactComponent as YellowVector } from '../../../assets/svg/bottom_yellow_vector.svg';
import { ReactComponent as GreyVectorSVG } from '../../../assets/svg/top_grey_vector.svg';
import { CoralText, GreyText } from '../Styled';

export const TopLeftVector = styled(GreyVectorSVG)`
    position: absolute;
    top: -3.6rem;
    left: 0;

    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.S.max;
        }}px) {
        left: -11.8rem;
        transform: scale(0.5);
    }
`;

export const BottomLeftVector = styled(YellowVector)`
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;

    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.M.max;
        }}px) {
        display: none;
    }
`;

export const BottomRightVector = styled(BottomRightYellowVector)`
    display: flex;
    position: fixed;
    bottom: 0;
    right: 0;

    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.S.max;
        }}px) {
        right: -12.3rem;
        transform: scale(0.5);
        bottom: -5.2rem;
    }
`;

export const Header = styled(Box)`
    margin: 0;
    padding: 0;
    height: 7.2rem;
    z-index: 99999;
    border-bottom: 0.15rem solid #dfe4e9;
    background: #fff;
    box-shadow: 0.2rem 0 0.8rem 0 rgba(176, 188, 200, 0.2), 0 0.2rem 0.8 0 rgba(176, 188, 200, 0.2);
`;

export const Content = styled(Box)`
    padding: 0;
    width: 100%;
    height: calc(100vh - 7.2rem);
    overflow-y: auto;
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        height: calc(100vh - 6.4rem);
    }
`;

export const ContentWrapper = styled('div')<{ hasBottomVector?: boolean }>`
    width: 100%;
    position: relative;
    height: ${({ hasBottomVector }) => (hasBottomVector ? 'max-content' : '100%')};
    min-height: 100%;

    @media (min-height: 860px) {
        height: auto;
    }
`;

export const OnboardingPageBackgroundBox = styled(Box)`
    height: 100%;
    width: 100%;
    padding: 0;
    border-radius: 0;
    background-size: cover;
    background-position: right center;
    background-repeat: no-repeat;
    background-color: ${({ theme }) => theme.colors.grey[50]};
    transition: none;
    display: flex;
    flex-direction: row;

    @media (max-width: ${({ theme }) => theme.breakpoints.L.max}px) {
        background-size: auto;
        background-position: bottom right;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        &&& {
            background-size: 100%;
            background-position: 50% 100%;
        }
    }
    @media (min-height: 1000px) {
        background-size: auto;
        background-position: bottom right;
    }
`;

export const OnboardingFormHeader = styled(Text)`
    color: ${({ theme }) => theme.colors.darkBlue};

    @media (min-width: ${({ theme }) => {
            return theme.breakpoints.S.max;
        }}px) {
        width: 47.5rem;
    }
`;

export const OnboardingFormHeader2 = styled(Text)`
    color: ${({ theme }) => theme.colors.darkBlue};

    @media (min-width: ${({ theme }) => {
            return theme.breakpoints.S.max;
        }}px) {
        width: 47.5rem;
    }
`;

export const OnboardingGreyText = styled(GreyText).attrs({ textVariant: 'body1', textAlign: 'center' })`
    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.M.max;
        }}px) {
        max-width: 29.5rem;
        br {
            display: none;
        }
    }
`;

export const OnboardingCoralText = styled(CoralText).attrs({ textVariant: 'body1', textWeight: 'Medium' })`
    cursor: pointer;
    text-decoration: none;
    margin-left: 0.4rem;
`;
